import { render, staticRenderFns } from "./GridVuesax.vue?vue&type=template&id=b5481438&"
import script from "./GridVuesax.vue?vue&type=script&lang=js&"
export * from "./GridVuesax.vue?vue&type=script&lang=js&"
import style0 from "./GridVuesax.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports